import send2 from "../../../assets/images/send2.svg";
import solu_mo from "../../../assets/images/solu_mo.webp";
import solu_pc from "../../../assets/images/solu_pc.webp";
import ModalTH from "../../Modal/ModalTH";

export default function ProductssSolu() {
  return (
    <div className="w-full lg:px-[120px] py-[40px]">
      <div className="container mx-auto p-3 flex flex-col gap-3 lg:flex-row lg:gap-3">
        <div className="flex flex-col gap-3">
          <p className="text-[28px] lg:text-[36px] text-[#033F6A] font-semibold">
            Giải pháp tiên phong từ BlueSkyIT
          </p>
          <p className="text-[16px] text-[#333333] font-normal lg:w-[650px]">
            BlueSkyIT tự hào mang đến các sản phẩm đột phá trong lĩnh vực giáo
            dục, sức khỏe và đào tạo, được thiết kế để mang lại giá trị vượt
            trội cho cộng đồng
          </p>
          <ModalTH />
        </div>
        <div>
          <img
            src={solu_mo}
            alt=""
            className="block md:hidden lg:hidden max-w-full h-auto"
          />
          <img
            src={solu_pc}
            alt=""
            className="hidden md:block lg:block w-[500px] h-auto object-cover"
          />
        </div>
      </div>
    </div>
  );
}
